import { DEFAULT_MARKER_CIRCLE_OPTIONS } from '~/app_constants';

export default ({ zIndex = 1, sizeRequired = true } = {}) => ({
  props: {
    marker: {
      type: Object,
      required: true,
    },
    size: {
      type: Object,
      required: sizeRequired,
    },
    zIndex: {
      type: Number,
      default: zIndex,
    },
    showRadius: {
      type: Boolean,
      default: false,
    },
    showInfoWindow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultMarkerCircleOptions: () => DEFAULT_MARKER_CIRCLE_OPTIONS,
  },
});
